<script lang="ts">
    import type {Conversation} from './types';
    import {createAutoUpdatingStore, getElapsedTime} from './service/util';

    export let conversation: Conversation;

    function getConversationWaitingTime() {
        return getElapsedTime(conversation.createDate, conversation.startDate || conversation.endDate || new Date());
    }

    const elapsedTime = createAutoUpdatingStore(() => getConversationWaitingTime(), 1000);
</script>

{#if $elapsedTime}
	<span>
		{$elapsedTime}
	</span>
{/if}